export default __webpack_public_path__ + "static/media/id-card.370039eb.svg";